module.exports = __webpack_public_path__ + "assets/img/section-3-landing-page-h3-squad.b7f0e328.png";